import Table from "@/components/Table/Table";
import styles from "@/pages/consumables/ConsumableDetail/ConsumableDetail.module.scss";
import { useGetConsumableRelationsPerYear } from "@/pages/consumables/useConsumables";

function ConsumableRelationsPerYear({ consumableId }: { consumableId: number }) {
  const { data, isLoading, isFetching } = useGetConsumableRelationsPerYear({
    consumableId,
  });
  return (
    <div className={styles.relationPerYearContainer}>
      <Table
        loading={isLoading || isFetching}
        type="grey"
        emptyState={{ hide: true }}
        hideRaster={true}
        data={data}
        columns={[
          {
            label: "Year",
            key: "year",
            renderer: (record) => (!record.year ? "Unrelated" : record.year),
          },
          {
            label: "Products",
            key: "product_count",
            renderer: (record) => record.product_count,
          },
          {
            label: "Facilities",
            key: "facility_count",
            renderer: (record) => record.facility_count,
          },
        ]}
        rowKey={"year"}
      />
    </div>
  );
}

export default ConsumableRelationsPerYear;
